import { render, staticRenderFns } from "./PopUpReferencesFile.vue?vue&type=template&id=1cd34c68&"
import script from "./PopUpReferencesFile.vue?vue&type=script&lang=js&"
export * from "./PopUpReferencesFile.vue?vue&type=script&lang=js&"
import style0 from "./PopUpReferencesFile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1cd34c68')) {
      api.createRecord('1cd34c68', component.options)
    } else {
      api.reload('1cd34c68', component.options)
    }
    module.hot.accept("./PopUpReferencesFile.vue?vue&type=template&id=1cd34c68&", function () {
      api.rerender('1cd34c68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dnt/vistas/modals/PopUpReferencesFile.vue"
export default component.exports